import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getAllChannels } from '../../../api/channels';

import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { normalizeChannelHovercardList } from '../../../components/Channels/utils/normalizeChannelHovercardList';

import { REQUEST } from '../../../constants/request';

// TODO: not refactored yet
export const fetchAllChannels = createAsyncThunk(
  `channels/fetchAllChannels`,
  async ({ params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getAllChannels(
        { params },
        {
          cancelToken: source.token,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (_, { getState }) => {
      const { channels } = getState();

      return !(
        channels.channels.displayChannels.request.loading === REQUEST.pending
      );
    },
  },
);

export const fetchAllChannelsExtraReducers = builder => {
  builder
    .addCase(fetchAllChannels.pending, (state, action) => {
      checkAndSetLoading(state.channels.displayChannels.request, action);
    })
    .addCase(fetchAllChannels.fulfilled, (state, action) => {
      onMatchedRequest(state.channels.displayChannels.request, action, () => {
        const { byId } = normalizeChannelHovercardList(action.payload);

        state.channels.displayChannels.layout.push(...Object.keys(byId));

        const resultById = {
          ...state.channels.hoveredChannels.byId,
          ...byId,
        };

        state.channels.hoveredChannels.byId = resultById;
        state.channels.hoveredChannels.allIds = Object.keys(resultById);
      });
    })
    .addCase(fetchAllChannels.rejected, (state, action) => {
      handleRequestRejection(state.channels.displayChannels.request, action);
    });
};
